<template>
    <div style="position: relative;left: 0;top: 0;bottom: 0;right: 0;width:100%;">
        <div class="left-head">
            <el-row>
                <el-col :span="24">用户信息</el-col>
            </el-row>
        </div>
        <div class="left">
            <div class="left-flex">
                <el-row>
                    <el-col :span="6" class="userInfo">
                        用户名称：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerName"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        用户编号：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerCode"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        用户地址：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerAddr"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        联系人：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerContactPerson"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        手机号码：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerMobile"></span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6" class="userInfo">
                        电子邮箱：
                    </el-col>
                    <el-col :span="18">
                        <span class="userInfoValue" v-text="customerEmail"></span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="right-head">
            <el-row>
                <el-col :span="24">数据分析
                    <div style="float: right">
                        <el-radio-group v-model="energyId" size="mini" style="padding-right: 1rem;padding-bottom: 0.9px">
                            <el-radio-button label="480d65f3-a47e-427c-b649-b3d179b3c0e2">电</el-radio-button>
                            <el-radio-button label="16396ef1-06a1-4896-a3d6-6c3eb17df360">水</el-radio-button>
                        </el-radio-group>
                        <el-button icon="el-icon-arrow-left" size="mini" @click="timeOffset(-1)" ></el-button>
                        <el-radio-group v-model="timeRange" size="mini" style="padding-bottom: 0.9px">
                            <el-radio-button label="1">月</el-radio-button>
                            <el-radio-button label="2">年</el-radio-button>
                        </el-radio-group>
                        <el-button icon="el-icon-arrow-right" size="mini" @click="timeOffset(1)" :disabled="cerrentTime" ></el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="right">
            <div class="energy-consumption-overview">
                <div class="overviwe">
                    <div class="" style="padding-left: 5rem">
                        <el-form :inline="true">
                            <el-form-item style="width: 49%">
                                <div>
                                    {{this.startDate.getFullYear()}}年{{this.timeRange === '1' ? this.startDate.getMonth() + 1 + '月' : ''}}
                                    总能耗量：<span class="content">{{this.energyConsumption.length === 0 ? '--' : this.totalEnergy}}{{this.energyId === '480d65f3-a47e-427c-b649-b3d179b3c0e2' ? 'kWh' : 'm³'}}</span>
                                </div>
                                <div>
                                    {{this.startDate.getFullYear()}}年{{this.timeRange === '1' ? this.startDate.getMonth() + 1 + '月' : ''}}
                                    总能耗费用：<span class="content">{{this.energyCost.length === 0 ? '--' : this.totalCost}}元</span>
                                </div>
                            </el-form-item>
                            <el-form-item style="width: 49%">
                                <div>
                                    {{this.timeRange === '1' ? '日' : '月'}}平均能耗量：<span class="content">{{this.energyConsumption.length === 0 ? '--' : this.averageEnergy}}{{this.energyId === '480d65f3-a47e-427c-b649-b3d179b3c0e2' ? 'kWh' : 'm³'}}</span>
                                </div>
                                <div>
                                    {{this.timeRange === '1' ? '日' : '月'}}平均能耗费用：<span class="content">{{this.preEnergyCost.length === 0 ? '--' : this.averageCost}}元</span>
                                </div>
                            </el-form-item>
                        </el-form>
                        <el-form :inline="true">
                            <el-form-item style="width: 49%">
                                <div>
                                    上期能耗量：<span class="content">{{this.preEnergyConsumption.length === 0 ? '--' : this.preTotalEnergy}}{{this.energyId === '480d65f3-a47e-427c-b649-b3d179b3c0e2' ? 'kWh' : 'm³'}}</span>
                                </div>
                                <div>
                                    上期能耗费用：<span class="content">{{this.preEnergyConsumption.length === 0 ? '--' : this.preTotalCost}}元</span>
                                </div>
                            </el-form-item>
                            <el-form-item style="width: 49%">
                                <div>
                                    能耗量环比变化率：<span v-bind:style="{color:this.energyRingRate === 101 ? '' : this.energyRingRate > 0 ? 'red' : 'green'}" >{{this.energyRingRate === 101 ? '--' : this.energyRingRate > 0 ? this.toPercent(this.energyRingRate) : this.toPercent(-this.energyRingRate) }}</span>
                                    <svg-icon :icon-class="this.energyRingRate === 101 ? '' : this.energyRingRate > 0 ? '箭头上升' : '箭头下降'" style="width: 1rem; height: 1rem"></svg-icon>
                                </div>
                                <div>
                                    能耗费用环比变化率：<span v-bind:style="{color:this.costRingRate === 101 ? '' : this.costRingRate > 0 ? 'red' : 'green'}" >{{this.costRingRate === 101 ? '--' : this.costRingRate > 0 ? this.toPercent(this.costRingRate) : this.toPercent(-this.costRingRate) }}</span>
                                    <svg-icon :icon-class="this.costRingRate === 101 ? '' : this.costRingRate > 0 ? '箭头上升' : '箭头下降'" style="width: 1rem; height: 1rem"></svg-icon>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="div-hr"></div>
            <div class="energy-consumption-trend-chart">
                <div class="toggle-button" style="padding-left: 2rem">
                    <el-form :inline="true">
                        <el-form-item>
                            <el-radio-group v-model="trendType" size="mini" >
                                <el-radio-button label="1">能耗量</el-radio-button>
                                <el-radio-button label="2">能耗费用</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
                <div id="trend" style="height: calc(100vh - 34.7rem);background-color: white;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { Message } from 'element-ui'
    import { getStartAndEnd, formatDate, format } from '@/utils/time'
    import { tree, expandedTenantPerentNode } from '@/utils/energyUtilTree'
    import { refreshTime } from "@/config/config"
    import Flex from "@/components/Flex";
    import { comdify, returnFloat } from "@/utils/numberUtil"
    import { fetchCustomerUserMeterEnergyDate } from "@/api/DataAnalysis";
    import echarts from 'echarts';
    import {queryCustomerById} from '@/api/customerUser'

    export default {
        name: "iEnergyAnalysis",
        components: {
            'flex': Flex
        },
        computed: {
            ...mapGetters([
                'customerId',
                'userId'
            ])
        },
        watch: {
            timeRange() {
                this.cerrentTime = true
                if(this.timeRange === '1'){
                    this.startDate = getStartAndEnd('now','month').start
                    this.endDate = new Date()
                }else{
                    this.startDate = getStartAndEnd('now','year').start
                    this.endDate = new Date()
                }
                this.fetchData(this.customerId, this.userId, this.energyId, formatDate(this.startDate), formatDate(this.endDate), this.timeRange)
            },
            energyId() {
                this.fetchData(this.customerId, this.userId, this.energyId, formatDate(this.startDate), formatDate(this.endDate), this.timeRange)
            },
            trendType() {
                this.trendSwitch()
            }
        },
        data() {
            return {
                energyId: '480d65f3-a47e-427c-b649-b3d179b3c0e2',
                timeRange: '1',
                tenantName: null,
                startDate: getStartAndEnd('now','month').start,
                endDate: new Date(),
                customerEnergyId: '',
                unit: 'kWh',//单位
                trendType: '1',//趋势图类型 1能耗量趋势图 2能耗费用趋势图
                trendCharts: null,//echarts趋势图
                totalEnergy: null,//本期总能耗
                preTotalEnergy: null,//上期总能耗
                totalCost: null,//本期总能耗费用
                preTotalCost: null,//上期总能耗费用
                averageEnergy: null,//平均能耗
                averageCost: null,//平均费用
                energyRingRate: null,//能耗环比
                costRingRate: null,//费用环比
                energyConsumption: [],//本期能耗量数组
                preEnergyConsumption: [],//上期能耗量数组
                energyCost: [],//本期能耗费用数组
                preEnergyCost: [],//上期能耗费用数组
                customerUserId: null,//业主用户id
                customerName: "",
                customerCode: "",
                customerMobile: "",
                customerAddr: "",
                customerEmail: "",
                customerContactPerson: "",
                cerrentTime: true,//到达当前时间不在允许点击下一个
            }
        },
        mounted() {
            this.queryUserInfo() //查询用户信息
            this.echartsInit()
        },
        methods: {
            toPercent(value){
                if(typeof value === 'undefined' || value === null || value === ''){
                    var str = Number(0).toFixed(2)
                    str+="%";
                    return str
                }
                var str = Number(value*100).toFixed(2)
                str+="%";
                return str
            },
            numberFormate: function(value){
                if(typeof value === 'undefined' || value === null || value === ''){
                    return Math.round(0*100)/100
                }
                return comdify(returnFloat(value))
            },
            trendSwitch: function () {
                //重置趋势图
                if(this.trendType === '1'){
                    //设置趋势图数据
                    this.trendCharts.setOption({
                        yAxis: {
                            name: this.energyId === '480d65f3-a47e-427c-b649-b3d179b3c0e2' ? '能耗量（kWh）' : '能耗量（m³）'
                        },
                        series: [
                            // 根据名字对应到相应的系列
                            {
                                name: '本期',
                                data: this.energyConsumption
                            },
                            {
                                name: '上期',
                                data: this.preEnergyConsumption
                            }
                        ]
                    })
                }else{
                    //设置趋势图数据
                    this.trendCharts.setOption({
                        yAxis: {
                            name: '能耗费用（元）'
                        },
                        series: [
                            // 根据名字对应到相应的系列
                            {
                                name: '本期',
                                data: this.energyCost
                            },
                            {
                                name: '上期',
                                data: this.preEnergyCost
                            }
                        ]
                    })
                }
            },
            fetchData: function (customerId, customerUserId, customerEnergyId, startDate,endDate,type) {
                const condition = {customerId: customerId, customerUserId: customerUserId, customerEnergyId: customerEnergyId, startDate: startDate, endDate: endDate, type: type}
                fetchCustomerUserMeterEnergyDate(condition).then(result => {
                    if(result.code === 200){
                        //设置data数组
                        this.energyConsumption = result.infoJson.energyConsumption
                        this.preEnergyConsumption = result.infoJson.preEnergyConsumption
                        this.energyCost = result.infoJson.energyCost
                        this.preEnergyCost = result.infoJson.preEnergyCost
                        //设置趋势图数据
                        this.trendSwitch()
                        this.trendCharts.setOption({
                            xAxis: {
                                data: result.infoJson.xAxis
                            },
                        })
                        //设置总览数据
                        this.totalEnergy = this.numberFormate(result.infoJson.totalEnergy)
                        this.preTotalEnergy = this.numberFormate(result.infoJson.preTotalEnergy)//上期总能耗
                        this.totalCost = this.numberFormate(result.infoJson.totalCost)//本期总能耗费用
                        this.preTotalCost = this.numberFormate(result.infoJson.preTotalCost)//上期总能耗费用
                        this.averageEnergy = this.numberFormate(result.infoJson.averageEnergy)//平均能耗
                        this.averageCost = this.numberFormate(result.infoJson.averageCost)//平均费用
                        this.energyRingRate = result.infoJson.energyRingRate//能耗环比
                        this.costRingRate = result.infoJson.costRingRate//费用环比
                        this.tenantName = result.infoJson.name//业主用户名称
                    }else{
                        Message({
                            message: result.message,
                            type: 'error',
                            duration: 5 * 1000
                        })
                    }
                })
            },
            timeOffset: function(value){
                const current = new Date()
                let startDate = this.startDate
                let endDate = this.endDate
                if(value < 0){
                    this.cerrentTime = false
                }
                if(this.timeRange === '1'){
                    //月
                    startDate.setMonth(startDate.getMonth() + value)
                    if(value > 0){
                        //12月→1月 年份+1
                        if(startDate.getMonth() === 0){
                            endDate.setFullYear(endDate.getFullYear() + value)
                            endDate.setMonth(0)
                            endDate.setDate(1)
                        }
                        //1月→2月 1月31日  月份直接+1由于日期为31会变成3月
                        if(startDate.getMonth() === 1){
                            endDate.setMonth(1)
                            endDate.setDate(1)
                        }
                        endDate.setMonth(startDate.getMonth() + value)
                    }
                    //上个月末
                    endDate.setDate(0)


                }else{
                    //年
                    startDate.setFullYear(startDate.getFullYear() + value)
                    endDate.setFullYear(endDate.getFullYear() + value)
                    endDate.setMonth(11)
                    endDate.setDate(31)
                }
                this.startDate = startDate
                this.endDate = endDate
                //回到当前时间 月份
                if(startDate.getFullYear() === current.getFullYear() && startDate.getMonth() === current.getMonth()){
                    this.cerrentTime = true
                    this.endDate = current
                }
                //回到当前时间 年份
                if(this.timeRange === '2' && startDate.getFullYear() === current.getFullYear()){
                    this.cerrentTime = true
                    this.endDate = current
                }
                this.fetchData(this.customerId, this.userId, this.energyId, formatDate(this.startDate), formatDate(this.endDate), this.timeRange)
            },
            echartsInit: function () {
                this.trendCharts = echarts.init(document.getElementById('trend'));
                // 显示标题，图例和空的坐标轴
                this.trendCharts.setOption({
                    title: {
                        show: false
                    },
                    color: ['#009BAC','#F8AD34'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        type: 'plain',
                        data:['本期','上期']
                    },
                    grid: {
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        data: []
                    },
                    yAxis: {
                        name: '能耗量（kWh）'
                    },
                    series: [
                        {
                            name:'本期',
                            type:'bar',
                            data:[]
                        },
                        {
                            name:'上期',
                            type:'bar',
                            data:[]
                        }
                    ]
                });

            },
            queryUserInfo() { //查询用户信息
                queryCustomerById(this.userId).then(response => {
                    let user = response.infoJson
                    if (user !== null && user !== undefined) {
                        if (user.realName !== null && user.realName !== undefined && user.realName !== "") {
                            this.customerName = user.realName
                        } else {
                            this.customerName = "--"
                        }
                        if (user.name !== null && user.name !== undefined && user.name !== "") {
                            this.customerCode = user.name
                        } else {
                            this.customerCode = "--"
                        }
                        if (user.mobile !== null && user.mobile !== undefined && user.mobile !== "") {
                            this.customerMobile = user.mobile
                        } else {
                            this.customerMobile = "--"
                        }
                        if (user.address !== null && user.address !== undefined && user.address !== "") {
                            this.customerAddr = user.address
                        } else {
                            this.customerAddr = "--"
                        }
                        if (user.email !== null && user.email !== undefined && user.email !== "") {
                            this.customerEmail = user.email
                        } else {
                            this.customerEmail = "--"
                        }
                        if (user.contactPerson !== null && user.contactPerson !== undefined && user.contactPerson !== "") {
                            this.customerContactPerson = user.contactPerson
                        } else {
                            this.customerContactPerson = "--"
                        }
                        this.fetchData(this.customerId, this.userId, this.energyId, formatDate(this.startDate), formatDate(this.endDate), this.timeRange)
                    } else {
                        this.$message({
                            type: 'error',
                            message: '用户信息查询失败'
                        })
                    }
                }).catch(error => {

                    this.$message({
                        type: 'error',
                        message: '用户信息查询失败'
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .el-col {
        line-height: 40px;
    }

    .el-col-24 {
        font-size: 15px;
        font-weight: 600;
    }

    .left {
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 0;
        width: 26%;
        height: calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;
        /*background-color: #ffffff;
        width: 25% ;
        padding-top: 2rem;
        height: calc(100vh - 12.5rem);*/
    }

    .left-flex {
        display: flex;
        flex-direction: column;
        height: calc(100% - 20px);
        width: calc(100% - 40px);
        margin: 10px 10px 10px 30px;
        font-size: 14px;
    }

    .right {
        position: absolute;
        left: 29%;
        top: 40px;
        bottom: 0;
        width: 71%;
        height: calc(95% - 40px);
        background-color: #ffffff;
        border-radius: 4px;
        overflow: auto;

    }

    .content {
        color: #009BAC;
    }

    .div-hr {
        height: 1px;
        background-color: #dedede;
    }

    .left-head {
        position: absolute;
        left: 0;
        width: 26%;
    }

    .right-head {
        position: absolute;
        left: 29%;
        width: 71%;
    }

    .userInfo {
        color: #6A6A6A;
        font-size: 14px;
    }

    .userInfoValue {
        font-size: 18px;
        word-break: break-all;
        color: black;
    }
</style>